// Step-up prompt singleton. The API client (services/api.js) calls request()
// when the server answers 403 TWO_FACTOR_REQUIRED; the one mounted
// <TwoFactorPromptModal/> subscribes, asks for a code and calls resolve()
// (verified) or reject() (cancelled). Concurrent requests share ONE prompt.
let pending = null;          // { promise, resolve, reject }
let listener = null;

const notify = (open) => { if (listener) listener(open); };

export const twoFactorPrompt = {
  request() {
    if (pending) return pending.promise;
    let res; let rej;
    const promise = new Promise((resolve, reject) => { res = resolve; rej = reject; });
    pending = { promise, resolve: res, reject: rej };
    notify(true);
    return promise;
  },
  subscribe(fn) {
    listener = fn;
    if (pending) fn(true);
    return () => { if (listener === fn) listener = null; };
  },
  resolve() {
    const p = pending; pending = null;
    notify(false);
    if (p) p.resolve();
  },
  reject(reason) {
    const p = pending; pending = null;
    notify(false);
    if (p) p.reject(reason || new Error('Two-factor confirmation cancelled'));
  },
};

export default twoFactorPrompt;
